import { Action } from 'redux'
import { isType } from 'ts-action'
import { IPayStubReducer } from 'models/PayStub'
import { GetPayStubs, PayStubsFetching } from './actions'

const initialState: IPayStubReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const payStubsReducer = (
  state = initialState,
  action: Action,
): IPayStubReducer => {
  if (isType(action, GetPayStubs)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, PayStubsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
